import { render, staticRenderFns } from "./setting-insurance-type-list.vue?vue&type=template&id=52ed9202&scoped=true&"
import script from "./setting-insurance-type-list.vue?vue&type=script&lang=js&"
export * from "./setting-insurance-type-list.vue?vue&type=script&lang=js&"
import style0 from "./setting-insurance-type-list.vue?vue&type=style&index=0&id=52ed9202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed9202",
  null
  
)

export default component.exports